import { render, staticRenderFns } from "./OpenEndedAggregate.vue?vue&type=template&id=2072a35a&"
import script from "./OpenEndedAggregate.vue?vue&type=script&lang=js&"
export * from "./OpenEndedAggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports